import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail } from "lucide-react";

const PHONE_DISPLAY = "(424) 222-1975";
const PHONE_TEL = "tel:+14242221975";
const WHATSAPP_URL = "https://wa.me/14242221975";

const IMAGES = {
  craft1: "https://images.unsplash.com/photo-1784039884562-50dcf22f8729?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHx0cnVjayUyMGRyaXZlciUyMHRhYmxldHxlbnwwfHx8fDE3OTI0NDI5NDJ8MA&ixlib=rb-4.1.0&q=85",
  craft2: "https://images.unsplash.com/photo-1592805144716-feeccccef5ac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxzZW1pJTIwdHJ1Y2slMjBoaWdod2F5JTIwc3Vuc2V0fGVufDB8fHx8MTc5MjQ0Mjk0Mnww&ixlib=rb-4.1.0&q=85",
  craft3: "https://images.pexels.com/photos/2449454/pexels-photo-2449454.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  proof: "https://images.pexels.com/photos/13569837/pexels-photo-13569837.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

const MARQUEE_ITEMS = [  <span key="a" className="text-[#111111]">KRATOS FREIGHT SYSTEM</span>,
  <span key="b"> · </span>,
  <span key="c" className="text-[#b45309]">VERIFIED ON-TIME DELIVERY</span>,
  <span key="d"> · </span>,
  <span key="e">RIGID SAFETY COMPLIANCE</span>,
  <span key="f"> · </span>,
  <span key="g">FULL TRUCKLOAD &amp; REGIONAL LTL</span>,
  <span key="h"> · </span>,
];

const CLIENTS = [
  { name: "First Logistics", logo: "/assets/clients/first-logistics.webp" },
  { name: "Nica Containers", logo: "/assets/clients/nica-containers.png" },
  { name: "IMC Logistics", logo: "/assets/clients/imc-logistics.png" },
  { name: "Forrest Logistics", logo: "/assets/clients/forrest-logistics.svg" },
];

const EMAIL_CONTACTS = [
  { name: "Di Nobrega", email: "dinobrega@kratostransportation.com" },
  { name: "Luis Arevalo", email: "luisarevalo@kratostransportation.com" },
];

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#f5f1e8] text-[#463f33]">
      {/* Navigation */}
      <nav className="border-b border-[#ddd4bf] bg-[#f5f1e8]/95 backdrop-blur sticky top-0 z-50 px-6 py-5">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          <div className="flex items-center" data-testid="brand-logo">
            <img
              src="/assets/kratos-logo.png"
              alt="Kratos Enterprise Logistics logo"
              className="h-[112px] w-auto"
            />
          </div>
          <div className="flex items-center gap-4">
            <a
              data-testid="nav-call-dispatch-btn"
              href={PHONE_TEL}
              className="mono text-xs uppercase tracking-wider text-[#6b6350] hover:text-[#b45309] transition-colors hidden sm:inline"
            >
              Call Dispatch
            </a>
            <a
              data-testid="nav-contact-dispatch-btn"
              href="#contact"
              className="mono text-xs uppercase tracking-wider px-4 py-2.5 bg-[#facc15] text-black font-bold hover:bg-[#eab308] transition-colors rounded-none"
            >
              Contact Dispatch
            </a>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="pt-16 pb-20 px-6 border-b border-[#ddd4bf] relative">
        <div className="max-w-6xl mx-auto">
          <div className="mono text-xs uppercase tracking-widest text-[#b45309] mb-6">
            Punctual Linehaul Delivery
          </div>

          <h1 className="editorial text-5xl sm:text-7xl lg:text-8xl text-[#111111] font-normal leading-[0.95] mb-8">
            <span className="ln"><span>UNRIVALED FREIGHT INTEGRITY</span></span>
            <span className="ln"><span className="italic text-[#b45309]">BUILT ON TRUST</span></span>
          </h1>

          <div className="grid lg:grid-cols-12 gap-8 items-end mb-12">
            <div className="lg:col-span-7">
              <p className="fade-hero text-lg sm:text-xl text-[#6b6350] leading-relaxed max-w-xl">
                Rooted in trustworthiness and efficiency, delivering high-value cargo with
                uncompromising precision.
              </p>
            </div>
            <div className="lg:col-span-5 flex flex-wrap gap-4 lg:justify-end">
              <a
                data-testid="hero-contact-btn"
                href="#contact"
                className="mono text-xs uppercase tracking-widest px-6 py-3.5 bg-[#facc15] text-black font-bold hover:bg-[#eab308] transition-colors"
              >
                Contact Dispatch
              </a>
              <a
                data-testid="hero-whatsapp-btn"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="mono text-xs uppercase tracking-widest px-6 py-3.5 border border-[#cbc1a8] text-[#111111] hover:border-[#25D366] hover:text-[#25D366] transition-colors"
              >
                WhatsApp Fast Line
              </a>
            </div>
          </div>

        </div>
      </section>

      {/* Marquee */}
      <div className="py-4 border-b border-[#ddd4bf] bg-[#fbf8f1] overflow-hidden" aria-hidden="true">
        <div className="mq-editorial mono text-xs uppercase tracking-widest text-[#6b6350]">
          <div className="flex items-center gap-12 shrink-0 pr-12">{MARQUEE_ITEMS}</div>
          <div className="flex items-center gap-12 shrink-0 pr-12">{MARQUEE_ITEMS}</div>
        </div>
      </div>

      {/* Fleet & services */}
      <section className="py-24 px-6 border-b border-[#ddd4bf]" id="fleet">
        <div className="max-w-6xl mx-auto">
          <div className="mb-16">
            <div className="mono text-xs uppercase tracking-widest text-[#b45309] mb-2">
              Freight Disciplines
            </div>
            <h2 className="editorial text-4xl sm:text-5xl text-[#111111]">THE KRATOS FLEET</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                img: IMAGES.craft1,
                alt: "Semi truck driver completing a digital inspection on a tablet next to truck wheels",
                title: "Dedicated Route Haul",
                copy: "Guaranteed trailer capacity and prioritized route scheduling for critical inventory cycles.",
                tag: "Direct Transit →",
                testid: "service-route-haul-card",
              },
              {
                img: IMAGES.craft2,
                alt: "Semi truck cabin cruising on a highway at sunset with a golden horizon reflection",
                title: "Regional Logistics",
                copy: "Reliable middle-mile distribution connecting manufacturing centers with local commercial hubs.",
                tag: "Regional Line →",
                testid: "service-regional-logistics-card",
              },
              {
                img: IMAGES.craft3,
                alt: "Modern semi truck at a loading dock at twilight with glowing safety lamps",
                title: "Expedited Cargo",
                copy: "Priority dispatch protocols engineered for urgent deadlines and specialized commercial cargo.",
                tag: "Fast Lane →",
                testid: "service-expedited-cargo-card",
              },
            ].map((s) => (
              <div
                key={s.title}
                data-testid={s.testid}
                className="border border-[#ddd4bf] bg-[#fbf8f1] p-6 flex flex-col justify-between hover:border-[#facc15]/40 transition-colors"
              >
                <div className="aspect-[4/3] overflow-hidden relative mb-6 border border-[#cbc1a8]">
                  <img src={s.img} alt={s.alt} loading="lazy" className="w-full h-full object-cover" />
                </div>
                <h3 className="editorial text-2xl text-[#111111] mb-2">{s.title}</h3>
                <p className="text-xs text-[#6b6350] leading-relaxed mb-6">{s.copy}</p>
                <span className="mono text-xs text-[#b45309] uppercase tracking-wider">{s.tag}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trust / accountability */}
      <section className="py-24 px-6 border-b border-[#ddd4bf] bg-[#efe9db]">
        <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="mono text-xs uppercase tracking-widest text-[#b45309] mb-2">
              Accountability
            </div>
            <h2 className="editorial text-4xl text-[#111111] mb-4">REPUTATION IN TRANSIT</h2>
            <p className="text-sm text-[#6b6350] leading-relaxed">
              Every load is secured, checked, and delivered with professional integrity.
            </p>
            <div className="aspect-video mt-6 border border-[#cbc1a8] relative overflow-hidden">
              <img
                src={IMAGES.proof}
                alt="Close-up of semi truck chrome mirrors and pristine black cabin paint"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="lg:col-span-7">
            <div
              className="p-8 border border-[#ddd4bf] bg-[#fbf8f1] text-center"
              data-testid="proof-panel"
            >
              <div className="mono text-xs uppercase tracking-widest text-[#b45309] mb-2">
                Performance Record
              </div>
              <h3 className="editorial text-2xl text-[#111111] mb-3">Client Delivery Audits</h3>
              <p className="text-xs text-[#6b6350] max-w-md mx-auto leading-relaxed mb-6">
                Official shipper reviews and verified punctuality logs will be featured here
                following active route reconciliations.
              </p>
              <span className="mono text-[10px] uppercase tracking-widest border border-[#facc15]/40 text-[#b45309] px-4 py-1.5 inline-block">
                Route Telemetry Pending
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Clients */}
      <section className="py-24 px-6 border-b border-[#ddd4bf]" id="clients">
        <div className="max-w-6xl mx-auto">
          <div className="mb-16">
            <div className="mono text-xs uppercase tracking-widest text-[#b45309] mb-2">
              Trusted Partnerships
            </div>
            <h2 className="editorial text-4xl sm:text-5xl text-[#111111]">OUR CLIENTS</h2>
          </div>
          <div className="max-w-3xl border border-[#ddd4bf] bg-[#fbf8f1] divide-y divide-[#ddd4bf]" data-testid="clients-list">
            {CLIENTS.map((c) => (
              <div
                key={c.name}
                data-testid={`client-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex items-center gap-6 px-8 py-7 hover:bg-[#efe9db] transition-colors"
              >
                <div className="w-40 h-16 shrink-0 bg-white border border-[#ddd4bf] flex items-center justify-center px-4 py-2">
                  <img
                    src={c.logo}
                    alt={`${c.name} logo`}
                    loading="lazy"
                    className="max-h-12 max-w-full object-contain"
                  />
                </div>
                <div>
                  <div className="editorial text-2xl text-[#111111]">{c.name}</div>
                  <div className="mono text-[10px] uppercase tracking-widest text-[#6b6350]">
                    Freight Partner
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact dispatch */}
      <section id="contact" className="py-24 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="mb-16">
            <div className="mono text-xs uppercase tracking-widest text-[#b45309] mb-2">
              Direct Dispatch
            </div>
            <h2 className="editorial text-4xl sm:text-5xl text-[#111111]">REACH KRATOS DISPATCH</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6 max-w-5xl">
            <div className="p-6 bg-[#fbf8f1] border border-[#ddd4bf] flex items-center justify-between">
              <div>
                <span className="mono text-[10px] uppercase text-[#b45309] flex items-center gap-1.5">
                  <Mail className="w-3 h-3" /> Written Line
                </span>
                <div className="editorial text-xl text-[#111111]">Email Dispatch</div>
                <p className="text-xs text-[#6b6350]">Send a detailed enquiry.</p>
              </div>
              <Link
                to="/contact"
                data-testid="email-contact-btn"
                className="px-4 py-2 bg-[#111111] text-[#f5f1e8] mono text-xs uppercase font-bold shrink-0 hover:bg-[#b45309] hover:text-black transition-colors"
              >
                Email
              </Link>
            </div>

            <div className="p-6 bg-[#fbf8f1] border border-[#ddd4bf] flex items-center justify-between" id="whatsapp">
              <div>
                <span className="mono text-[10px] uppercase text-[#25D366] flex items-center gap-1.5">
                  <MessageCircle className="w-3 h-3" /> Direct Dispatch
                </span>
                <div className="editorial text-xl text-[#111111]">WhatsApp Line</div>
                <p className="text-xs text-[#6b6350]">Instant route assistance · {PHONE_DISPLAY}</p>
              </div>
              <a
                data-testid="whatsapp-chat-btn"
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="px-4 py-2 bg-[#25D366] text-black mono text-xs uppercase font-bold shrink-0 hover:bg-[#1fb857] transition-colors"
              >
                Chat
              </a>
            </div>

            <div className="p-6 bg-[#fbf8f1] border border-[#ddd4bf] flex items-center justify-between" id="call">
              <div>
                <span className="mono text-[10px] uppercase text-[#b45309] flex items-center gap-1.5">
                  <Phone className="w-3 h-3" /> Direct Line
                </span>
                <div className="editorial text-xl text-[#111111]">Voice Call</div>
                <p className="text-xs text-[#6b6350]">Speak directly with dispatch · {PHONE_DISPLAY}</p>
              </div>
              <a
                data-testid="call-dispatch-btn"
                href={PHONE_TEL}
                className="px-4 py-2 border border-[#facc15] text-[#b45309] mono text-xs uppercase font-bold shrink-0 hover:bg-[#facc15] hover:text-black transition-colors"
              >
                Call
              </a>
            </div>
          </div>

          <div className="mt-10 max-w-5xl">
            <div className="mono text-xs uppercase tracking-widest text-[#b45309] mb-4">
              Direct Email Contacts
            </div>
            <div className="grid md:grid-cols-2 gap-6">
              {EMAIL_CONTACTS.map((p) => (
                <a
                  key={p.email}
                  href={`mailto:${p.email}`}
                  data-testid={`email-${p.email.split("@")[0]}`}
                  className="p-6 bg-[#fbf8f1] border border-[#ddd4bf] flex items-center gap-4 hover:border-[#b45309]/60 transition-colors group"
                >
                  <Mail className="w-5 h-5 text-[#b45309] shrink-0" />
                  <div>
                    <div className="editorial text-xl text-[#111111]">{p.name}</div>
                    <div className="mono text-[11px] text-[#6b6350] group-hover:text-[#b45309] transition-colors break-all">
                      {p.email}
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
      <footer className="py-12 px-6 border-t border-[#ddd4bf] bg-[#e4dcc9] text-[#6b6350] mono text-xs">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center" data-testid="footer-brand">
            <img
              src="/assets/kratos-logo.png"
              alt="Kratos Enterprise Logistics logo"
              className="h-[78px] w-auto"
            />
          </div>
          <div className="text-[11px] uppercase">Precision • Efficiency • Unwavering Trust</div>
        </div>
      </footer>
    </div>
  );
}
